import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Checkbox,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Radio,
  Well
} from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import { browserHistory } from 'react-router'
import { Elements } from 'react-stripe-elements'
import Loadable from 'react-loading-overlay'

import Addresses from './addresses'
import AssmanButton from '../../utils/assmanbutton';
import Collapsible from '../collapsible'
import CompanyNavigation from './companynavigation'
import Contacts from './contacts'
import Notes from './notes'
import SavedCards from './savedcards'
import Tasks from './tasks'
import Validators from '../../utils/validators'
import NewCompanyForm from '../companies/newcompanyform'

@observer(['activities', 'categories', 'companies', 'users', 'companystates', 'addresses', 'partners', 'vendors', 'sources', 'quickbooks', 'globals'])
export default class Details extends Component {
  constructor(props) {
    super(props)

    let companyId = this.props.params.companyId
    let taskId = 0
    let noteId = 0

    if (this.props.params.type && this.props.params.type == 'task') {
      taskId = this.props.params.typeId
    }

    if (this.props.params.type && this.props.params.type == 'note') {
      noteId = this.props.params.typeId
    }

    //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
    //this.props.activities.logNewActivity(localStorage.getItem('userId'), 'read', 4, companyId, 3, localStorage.getItem('userOrganizationId'))

    this.state = {
      repId: 0,
      ogRepId: 0,
      userFullName: 'Loading...',
      companyName: 'Loading...',
      defaultContactId: 0,
      defaultBillingAddressId: 0,
      defaultShippingAddressId: 0,
      qbCustomerId: 0,
      contactFirstName: 'Loading...',
      contactLastName: 'Loading...',
      contactTitle: 'Loading...',
      contactEmail: 'Loading...',
      contactPhone: 'Loading...',
      salesNote: 'Loading...',
      companyStateId: 0,
      companyState: 'Loading...',
      vendorId: 0,
      vendorName: 'Loading...',
      sourceId: 0,
      sourceName: 'Loading...',
      partnerId: 0,
      partnerFullName: 'Loading....',
      categoryId: 0,
      categoryName: 'Loading...',
      qbCustomerId: 0,
      freeShipping: 0,
      loadableState: true,
      showNewCompanyForm: false,
      newAssigned: 0,
      taskId: taskId,
      noteId: noteId,
      taxable: 1
    }

    this.props.categories.loadAllCategories()
    this.props.users.loadAllOrganizationUsers(localStorage.getItem('userOrganizationId'))
    this.props.companystates.loadAllCompanyStates()
    this.props.partners.loadAllOrganizationPartners(localStorage.getItem('userOrganizationId'))
    this.props.vendors.loadAllVendors()
    this.props.sources.loadAllSources()
    this.loadCompanyDetails(companyId)
    //this.forceUpdate()
  }

  setLoadableState(state) {
    if (state) {
      this.setState({
        loadableState: true
      })
    } else {
      this.setState({
        loadableState: false
      })
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.params && newProps.params.companyId) {
      this.setLoadableState(true)
      this.loadCompanyDetails(newProps.params.companyId)
    }
  }

  refreshCompanyDetails() {
    this.setLoadableState(true)
    this.loadCompanyDetails(this.props.params.companyId)
  }

  onSetDefaultContactId(contactId) {
    this.setState({
      defaultContactId: contactId
    })
  }

  onSetDefaultBillingAddressId(billingAddressId) {
    this.setState({
      defaultBillingAddressId: billingAddressId
    })
  }

  onSetDefaultShippingAddressId(shippingAddressId) {
    this.setState({
      defaultShippingAddressId: shippingAddressId
    })
  }

  loadCompanyDetails(companyId, callback) {
    this.props.companies.loadCompanyDetails({id: companyId, hash: localStorage.getItem('userHash') }, (data) => {
      this.props.companies.countNewlyAssignedLeads()
      this.setState({
        repId: data.userId,
        ogRepId: data.userId,
        newAssigned: data.newAssigned,
        userFullName: data.userFullName,
        companyName: data.name,
        defaultContactId: data.defaultContactId,
        defaultBillingAddressId: data.defaultBillingAddressId,
        defaultShippingAddressId: data.defaultShippingAddressId,
        qbCustomerId: data.qbCustomerId,
        contactFirstName: data.contactFirstName,
        contactLastName: data.contactLastName,
        contactTitle: data.contactTitle,
        contactEmail: data.contactEmail,
        contactPhone: data.contactPhone,
        salesNote: data.salesNote,
        companyStateId: data.companyStateId,
        companyState: data.companyState,
        vendorId: data.vendorId,
        vendorName: data.vendorName,
        sourceId: data.sourceId,
        sourceName: data.sourceName,
        partnerId: data.partnerId,
        partnerFullName: data.partnerFullName,
        categoryId: data.categoryId,
        categoryName: data.categoryName,
        qbCustomerId: data.qbCustomerId,
        freeShipping: data.freeShipping,
        loadableState: false,
        taxable: data.taxable
      })

      if (callback) {
        callback()
      }
    })
  }

  validateEditCompanyForm() {
    if (this.getEditCompanyRepIdValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyNameValidationState() == 'error') {
      return false
    }

    /*
    if (this.getEditPartnerValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyContactTitleValidationState() == 'error') {
      return false
    }
    */

    if (this.getEditCompanyContactFirstNameValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyContactLastNameValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyContactEmailValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyContactPhoneValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyCategoryValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyCompanyStateValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanyVendorValidationState() == 'error') {
      return false
    }

    if (this.getEditCompanySourceValidationState() == 'error') {
      return false
    }
    return true
  }

  validateQuickBookCreateCustomerSubmission() {
    if (this.props.companies.details.name == null || this.props.companies.details.name == '') {
      return false
    }
    if (this.props.companies.details.billingAddressAddress == null || this.props.companies.details.billingAddressAddress == '') {
      return false
    }
    if (this.props.companies.details.billingAddressCity == null || this.props.companies.details.billingAddressCity == '') {
      return false
    }
    if (this.props.companies.details.billingAddressState == null || this.props.companies.details.billingAddressState == '') {
      return false
    }
    if (this.props.companies.details.billingAddressZipCode == null || this.props.companies.details.billingAddressZipCode == '') {
      return false
    }
    if (this.props.companies.details.contactFirstName == null || this.props.companies.details.contactFirstName == '') {
      return false
    }
    if (this.props.companies.details.contactLastName == null || this.props.companies.details.contactLastName == '') {
      return false
    }
    if (this.props.companies.details.contactPhone == null || this.props.companies.details.contactPhone == '') {
      return false
    }
    if (this.props.companies.details.contactEmail == null || this.props.companies.details.contactEmail == '') {
      return false
    }
    /*
    if (this.props.companies.details.salesNote == null || this.props.companies.details.salesNote == '') {
      return false
    }
    */
    return true
  }

  getEditCompanyRepIdValidationState() {
    if (this.state && this.state.repId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyNameValidationState() {
    if (this.state && Validators.validString(this.state.companyName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  /*
  getEditPartnerValidationState() {
    if (this.state && Validators.validString(this.state.partnerId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyContactTitleValidationState() {
    if (this.state && Validators.validString(this.state.contactTitle)) {
      return 'success'
    } else {
      return 'error'
    }
  }
  */

  getEditCompanyContactFirstNameValidationState() {
    if (this.state && Validators.validString(this.state.contactFirstName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyContactLastNameValidationState() {
    if (this.state && Validators.validString(this.state.contactLastName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyContactEmailValidationState() {
    if (this.state && Validators.validString(this.state.contactEmail)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyContactPhoneValidationState() {
    if (this.state && Validators.validString(this.state.contactPhone)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyCategoryValidationState() {
    if (this.state && this.state.categoryId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyCompanyStateValidationState() {
    if (this.state && this.state.companyStateId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanyVendorValidationState() {
    if (this.state && this.state.vendorId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditCompanySourceValidationState() {
    if (this.state && this.state.sourceId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  editCompanyNameChanged(e) {
    this.setState({
      companyName: e.target.value
    })
  }

  editCompanyContactTitleChanged(e) {
    this.setState({
      contactTitle: e.target.value
    })
  }

  editCompanyContactFirstNameChanged(e) {
    this.setState({
      contactFirstName: e.target.value
    })
  }

  editCompanyContactLastNameChanged(e) {
    this.setState({
      contactLastName: e.target.value
    })
  }

  editCompanyContactEmailChanged(e) {
    this.setState({
      contactEmail: e.target.value
    })
  }

  editCompanyContactPhoneChanged(e) {
    this.setState({
      contactPhone: e.target.value
    })
  }

  editCompanySalesNoteChanged(e) {
    this.setState({
      salesNote: e.target.value
    })
  }

  onRepChanged(e) {
    if (e.length > 0) {
      if (this.state.ogRepId != e[0].id) {
        this.setState({
          newAssigned: 1
        })
      } else {
        this.setState({
          newAssigned: 0
        })
      }
    } else {
        this.setState({
          newAssigned: 0
        })
    }

    if (e.length > 0) {
      this.setState({
        repId: e[0].id,
        userFullName: e[0].name
      })
    } else {
      this.setState({
        repId: 0,
        userFullName: ''
      })
    }
  }

  onCategoryChanged(e) {
    if (e.length > 0) {
      this.setState({
        categoryId: e[0].id,
        categoryName: e[0].name
      })
    } else {
      this.setState({
        categoryId: 0,
        categoryName: ''
      })
    }
  }

  onCompanyStateChanged(e) {
    if (e.length > 0) {
      this.setState({
        companyStateId: e[0].id,
        companyState: e[0].name
      })
    } else {
      this.setState({
        companyStateId: 0,
        companyState: ''
      })
    }
  }

  onVendorChanged(e) {
    if (e.length > 0) {
      this.setState({
        vendorId: e[0].id,
        vendorName: e[0].name
      })
    } else {
      this.setState({
        vendorId: 0,
        vendorName: ''
      })
    }
  }

  onSourceChanged(e) {
    if (e.length > 0) {
      this.setState({
        sourceId: e[0].id,
        sourceName: e[0].name
      })
    } else {
      this.setState({
        sourceId: 0,
        sourceName: ''
      })
    }
  }

  onPartnerChanged(e) {
    if (e.length > 0) {
      this.setState({
        partnerId: e[0].id,
        partnerFullName: e[0].fullName
      })
    } else {
      this.setState({
        partnerId: 0,
        partnerFullName: ''
      })
    }
  }

  onFreeShippingChanged(e) {
    if (e.target.checked) {
      this.setState({
        freeShipping: 1
      }, () => {
        this.updateFreeShippingStatus()
      })
    } else {
      this.setState({
        freeShipping: 0
      }, () => {
        this.updateFreeShippingStatus()
      })
    }
  }

  updateFreeShippingStatus() {
    const params = {
      id: this.props.companies.details.id,
      freeShipping: this.state.freeShipping
    }

    this.props.companies.updateFreeShippingStatus(params, (data) => {
      alert('Free shipping status updated successfully!')
    })
  }

  onChangeTaxable(e) {
    let val = 0
    if (this.state.taxable == 0) {
      val = 1
    } else {
      val = 0
    }
    this.setState({
      taxable: val
    })
  }

  onSave(e) {
    this.setLoadableState(true)

    const params = {
      id: this.props.companies.details.id,
      userId: this.state.repId,
      newAssigned: this.state.newAssigned,
      name: this.state.companyName,
      categoryId: this.state.categoryId,
      companyStateId: this.state.companyStateId,
      vendorId: this.state.vendorId,
      sourceId: this.state.sourceId,
      /*
      firstName: this.state.contactFirstName,
      lastName: this.state.contactLastName,
      title: this.state.contactTitle,
      email: this.state.contactEmail,
      phone: this.state.contactPhone,
      */
      partnerId: this.state.partnerId,
      salesNote: this.state.salesNote,
      taxable: this.state.taxable,
      hash: localStorage.getItem('userHash')
    }

    if (this.validateEditCompanyForm()) {
      this.props.companies.updateCompany(params, (data) => {
        //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 4, this.props.companies.details.id, 3, localStorage.getItem('userOrganizationId'))

        //Check if company was converted to a customer.  If so, make API call to store new customer in QB.
        if (data.qbCustomerId == 0 && data.companyStateId == 3) {
          this.createQuickbooksCustomer()
        } else if (data.qbCustomerId > 0) {
          this.updateQuickbooksCustomer((data) => {
            if(data.quickbooksUpdateCustomer.statusCode == 200) {
              this.loadCompanyDetails(this.props.params.companyId, (company) => {
                alert('Customer successfully updated.')
              })
            } else {
              alert( data.quickbooksUpdateCustomer.data.message )
            }
          })
        } else {
          this.setLoadableState(false)
        }
      })
    } else {
      alert('Please check the form.  Required data is missing.')
      this.setLoadableState(false)
    }
  }

  back(e) {
    browserHistory.push('/companies')
  }

  openNewCompanyForm() {
    this.setState({
      showNewCompanyForm: true
    })
  }

  closeNewCompanyForm() {
    this.setState({
      showNewCompanyForm: false
    })
  }

  createQuickbooksCustomer() {
    this.setLoadableState(true)

    let companyId = this.props.params.companyId

    if (this.validateQuickBookCreateCustomerSubmission()) {
      this.props.quickbooks.quickbooksCreateCustomer(companyId, (data) => {
        if(data.quickbooksCreateCustomer.statusCode == 200) {
          this.loadCompanyDetails(this.props.params.companyId, (company) => {
            alert('Customer successfully created in Quickbooks.')
            this.setLoadableState(false)
          })
        } else {
          alert( data.quickbooksCreateCustomer.data.message )
          this.setLoadableState(false)
        }
      })
    } else {
      alert('Please check the form.  Required data is missing.')
      this.setLoadableState(false)
    }
  }


  updateQuickbooksCustomer(callback) {
    let companyId = this.props.params.companyId

    if (this.validateQuickBookCreateCustomerSubmission()) {
      this.props.quickbooks.quickbooksUpdateCustomer(companyId, (data) => {
        return callback(data)
      })
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  render() {
    let qbButtonDisplay = <Button bsStyle="success" onClick={ this.createQuickbooksCustomer.bind(this) }>Add To QB</Button>

    if (this.state.qbCustomerId > 0) {
      qbButtonDisplay = <Button disabled={ true }>In QB</Button>
    }

    var detailsPanel = (
      <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
        <div>
          <Button bsStyle="info" onClick={this.openNewCompanyForm.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
          <div>
            <Well bsSize="small">
              <Form horizontal name="partnerSelection">
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 2 }>Free Shipping:</Col>
                  <Col sm={ 6 }><Checkbox inline onChange={ this.onFreeShippingChanged.bind(this) } id="freeShipping" checked={this.state.freeShipping}></Checkbox></Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 2 }>Billing Status:</Col>
                  <Col sm={ 6 }><FormControl disabled id="billingStatus" value={ this.props.companies.details.billingStatus } /></Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 2 }>Partner Name:</Col>
                  <Col sm={ 6 }>
                    <FormGroup>
                      <Typeahead clearButton labelKey="fullName" options={ this.props.partners.data } onChange={ this.onPartnerChanged.bind(this) } selected={ [{ id: this.state.partnerId, fullName: this.state.partnerFullName }] } placeholder="Choose a partner..." />
                    </FormGroup>
                  </Col>
                </FormGroup>
              </Form>
            </Well>
          </div>
          <div>
            <Form horizontal name="companyDetails">
              <div className="col-md-6 col-sm-6 col-xs-12">
                <FormGroup>
                  <Col sm={4} componentClass={ ControlLabel } >Assigned Rep:</Col>
                  <Col sm={8} >
                    <FormGroup validationState={ this.getEditCompanyRepIdValidationState() }>
                      <Typeahead clearButton labelKey="name" options={ this.props.users.all } onChange={ this.onRepChanged.bind(this) } selected={ [{ id: this.state.repId, name: this.state.userFullName }] } placeholder="Choose a user..." />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={4} componentClass={ ControlLabel }>Company Name:</Col>
                  <Col sm={8} >
                    <FormGroup validationState={ this.getEditCompanyNameValidationState() }>
                      <FormControl type="text" id="companyName" placeholder="Company name" onChange={ this.editCompanyNameChanged.bind(this) } value={ this.state.companyName } />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={4} componentClass={ ControlLabel } >Sales Note:</Col>
                  <Col sm={8}><FormControl componentClass="textarea" id="salesNote" onChange={ this.editCompanySalesNoteChanged.bind(this) } value={ this.state.salesNote } /></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={4} componentClass={ ControlLabel }>QB Status:</Col>
                  <Col sm={8}> 
                    { qbButtonDisplay }
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={4} componentClass={ ControlLabel }>AssMan Status:</Col>
                  <Col sm={8}>
                    <AssmanButton companyId={this.props.params.companyId} />
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={4}>Taxable</Col>
                  <Col sm={8}>
                    <Radio name="taxable" inline checked={this.state.taxable == 1} onChange={this.onChangeTaxable.bind(this)}>
                      Yes
                    </Radio>
                    {' '}
                    <Radio name="taxable" inline checked={this.state.taxable == 0} onChange={this.onChangeTaxable.bind(this)}>
                      No
                    </Radio>
                  </Col>
                </FormGroup>
                { /*
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 4 }>Contact Name:</Col>
                  <Col sm={ 4 }>
                      <FormGroup validationState={ this.getEditCompanyContactFirstNameValidationState() }>
                        <FormControl id="contactFirstName" placeholder="First name" onChange={ this.editCompanyContactFirstNameChanged.bind(this) } value={ this.state.contactFirstName } />
                      </FormGroup>
                    </Col>
                  <Col sm={ 4 }>
                    <FormGroup validationState={ this.getEditCompanyContactLastNameValidationState() }>
                      <FormControl id="contactLastName" placeholder="Last name" onChange={ this.editCompanyContactLastNameChanged.bind(this) } value={ this.state.contactLastName } />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 4 }>Title:</Col>
                  <Col sm={ 8 }>
                    <FormGroup>
                      <FormControl id="contactTitle" placeholder="Title" onChange={ this.editCompanyContactTitleChanged.bind(this) } value={ this.state.contactTitle } />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 4 }>Email:</Col>
                  <Col sm={ 8 }>
                    <FormGroup validationState={ this.getEditCompanyContactEmailValidationState() }>
                      <FormControl id="contactEmail" placeholder="Email" onChange={ this.editCompanyContactEmailChanged.bind(this) } value={ this.state.contactEmail } />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 4 }>Phone:</Col>
                  <Col sm={ 8 }>
                    <FormGroup validationState={ this.getEditCompanyContactPhoneValidationState() }>
                      <FormControl id="contactPhone" placeholder="Phone" onChange={ this.editCompanyContactPhoneChanged.bind(this) } value={ this.state.contactPhone } />
                    </FormGroup>
                  </Col>
                </FormGroup>
                */ }
              </div>
              <div className="col-md-6 col-sm-6 col-xs-12">
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 2 }>Industry:</Col>
                  <Col sm={ 8 }>
                    <FormGroup validationState={ this.getEditCompanyCategoryValidationState() }>
                      <Typeahead clearButton labelKey="name" options={ this.props.categories.data } onChange={ this.onCategoryChanged.bind(this) } selected={ [{ id: this.state.categoryId, name: this.state.categoryName }] } placeholder="Choose a category..."  />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 2 }>State:</Col>
                  <Col sm={ 8 }>
                    <FormGroup validationState={ this.getEditCompanyCompanyStateValidationState() }>
                      <Typeahead clearButton labelKey="name" options={ this.props.companystates.data } onChange={ this.onCompanyStateChanged.bind(this) } selected={ [{ id: this.state.companyStateId, name: this.state.companyState }] } placeholder="Choose a state..."  />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 2 }>Vendor:</Col>
                  <Col sm={ 8 }>
                    <FormGroup validationState={ this.getEditCompanyVendorValidationState() }>
                      <Typeahead clearButton labelKey="name" options={ this.props.vendors.data } onChange={ this.onVendorChanged.bind(this) } selected={ [{ id: this.state.vendorId, name: this.state.vendorName }] } placeholder="Choose a vendor..."  />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ ControlLabel } sm={ 2 }>Source:</Col>
                  <Col sm={ 8 }>
                    <FormGroup validationState={ this.getEditCompanySourceValidationState() }>
                      <Typeahead clearButton labelKey="name" options={ this.props.sources.data } onChange={ this.onSourceChanged.bind(this) } selected={ [{ id: this.state.sourceId, name: this.state.sourceName }] } placeholder="Choose a source..."  />
                    </FormGroup>
                  </Col>
                </FormGroup>
              </div>
              <div className="clearfix"></div>
              <div>
                <FormGroup>
                  <Col colSpan={2}>
                    <Button className={'pull-right'} bsStyle="success" onClick={ this.onSave.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
                  </Col>
                </FormGroup>
              </div>
            </Form>
          </div>
        </div>
      </Loadable>
    )

    var notesPanel = (
      <div>
        <Notes companyId={ this.props.params.companyId } noteId={ this.state.noteId } defaultContactId={ this.state.defaultContactId }/>
      </div>
    )

    var tasksPanel = (
      <div>
        <Tasks companyId={ this.props.params.companyId } taskId={ this.state.taskId } />
      </div>
    )

    var addressesPanel = (
      <div>
        <Addresses companyId={ this.props.params.companyId } qbCustomerId={ this.state.qbCustomerId } showButtons={ true } defaultBillingAddressId={ this.state.defaultBillingAddressId } defaultShippingAddressId={ this.state.defaultShippingAddressId } onSetDefaultBillingAddressId={ this.onSetDefaultBillingAddressId.bind(this) } onSetDefaultShippingAddressId={ this.onSetDefaultShippingAddressId.bind(this)} updateQuickbooksCustomer={ this.updateQuickbooksCustomer.bind(this) } />
      </div>
    )

    var contactsPanel = (
      <div>
        <Contacts companyId={ this.props.params.companyId } defaultContactId={ this.state.defaultContactId } qbCustomerId={ this.state.qbCustomerId } onSetDefaultContactId={ this.onSetDefaultContactId.bind(this) } updateQuickbooksCustomer={ this.updateQuickbooksCustomer.bind(this) }/>
      </div>
    )

    var savedCardsPanel = (
      <div>
        <Elements>
          <SavedCards companyId={ this.props.params.companyId } />
        </Elements>
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <CompanyNavigation activeKey="1" companyId={ this.props.params.companyId } companyStateId={ this.props.companies.details.companyStateId } companyState={ this.props.companies.details.companyState } companyName={ this.props.companies.details.name } />
          <div>
            <div className="clearfix"></div>
                <Collapsible title="Details" content={ detailsPanel } />
            <div className="clearfix"></div>
              <Collapsible title="Contacts" content={ contactsPanel } />
            <div className="clearfix"></div>
              <Collapsible title="Addresses" content={ addressesPanel } />
            <div className="clearfix"></div>
              <Collapsible title="Notes" content={ notesPanel } />
            <div className="clearfix"></div>
              <Collapsible title="Tasks" content={ tasksPanel } />
            <div className="clearfix"></div>
              <Collapsible title="Saved Cards" content={ savedCardsPanel } />
          </div>
        <div style={{ clear: 'both' }}></div>
        <div>
          <div>
            <NewCompanyForm
              companyStateId={ this.props.companies.details.companyStateId }
              showNewCompanyForm={ this.state.showNewCompanyForm }
              onClose={ this.closeNewCompanyForm.bind(this) } 
              refreshCompanyDetails={ this.refreshCompanyDetails.bind(this) }
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/details.js